import { ProductRead } from "types"
import Callout from "./callout"
import { useTranslation } from "react-i18next"

interface StockFormCalloutProps {
    product?: ProductRead
    amount: number
}

const StockFormCallout: React.FC<StockFormCalloutProps> = ({ product, amount }) => {

    const { t } = useTranslation()

    if (!product) return null

    const calloutNode =
        amount !== 0 && product?.status?.currentAmount !== undefined && (
            product.status.currentAmount + amount === 0 ? <Callout type={`error`}>{t('willLeadToEmptyInventory')}</Callout> :
            product.status.currentAmount + amount < 0 ? (
                product.stockSettings.allowNegativeInventory ?
                    <Callout type={`warning`}>{t('willLeadToNegativeInventory')}</Callout> :
                    <Callout type={`error`}>{t('negativeStockIsNotAllowedForThisProduct')}</Callout>
            ) : product.stockSettings.lowStockWarning !== undefined && product.status.currentAmount + amount <= product.stockSettings.lowStockWarning && <Callout type={`warning`}>{t('willLeadToEarlyWarning')}</Callout>
        )

    return <>{ calloutNode }</>

}

export default StockFormCallout

